import { ModuleType } from '../types/module-type';
import { BillingModuleType } from '../types/billing-module-type';
import { createMap } from '@fi-shared/utils/create-map';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export interface IModuleTypesItem {
    Id: ModuleType;
    TextId: string;
    BaseState?: string;
}

export const ModuleTypes: IModuleTypesItem[] = [
    {
        Id: ModuleType.Core,
        TextId: 'common.our_organisation',
        BaseState: 'Core',
    },
    {
        Id: ModuleType.Document,
        TextId: 'common.pages',
        BaseState: FiStateNames.Document._name,
    },
    {
        Id: ModuleType.MediaBank,
        TextId: 'common.files',
        BaseState: FiStateNames.MediaBank._name,
    },
    {
        Id: ModuleType.Email,
        TextId: 'common.email',
        BaseState: 'Module.Email',
    },
    {
        Id: ModuleType.Post,
        TextId: 'posts',
    },
    /*{
    Id: ModuleType.CustomMindMapImport,
    TextId: 'module.handbook_import', // todo remove labels later
    BaseState: FiStateNames.Import.Handbook.MindMap
},*/ {
        Id: ModuleType.CustomFranchiseIntranetUpgrade,
        TextId: 'upgrade.upgrades',
        BaseState: FiStateNames.Upgrade._name,
    },
    /*{
    Id: ModuleType.CustomImportSystemObjects,
    TextId: 'module.organization_import', // todo remove labels later
    BaseState: FiStateNames.Import.SystemObject,
},*/ {
        Id: ModuleType.Billing,
        TextId: 'billing.billing',
        BaseState: FiStateNames.Billing._name,
    },
    {
        Id: ModuleType.ConfidentialAgreement,
        TextId: 'agreement.confidencial_agreement',
    },
    {
        Id: ModuleType.NewsFeed,
        TextId: 'module.news_feed',
    },
    {
        Id: ModuleType.Template,
        TextId: 'common.page_template',
        BaseState: FiStateNames.Document.Template._name,
    },
    {
        Id: ModuleType.Widget,
        TextId: 'common.widgets',
    },
    {
        Id: ModuleType.Tag,
        TextId: 'common.tags',
        BaseState: 'Tag',
    },
    {
        Id: ModuleType.Event,
        TextId: 'common.event',
    },
    {
        Id: ModuleType.Statistics,
        TextId: 'common.statistics',
        BaseState: FiStateNames.Statistic2._name,
    },
    {
        Id: ModuleType.FirstPage,
        TextId: 'First page',
    },
    {
        Id: ModuleType.SMS,
        TextId: 'sms_module_name',
        BaseState: FiStateNames.SMS._name,
    },
    {
        Id: ModuleType.CheckList,
        TextId: 'checklist.module_name',
        BaseState: FiStateNames.Checklist._name,
    },
    {
        Id: ModuleType.CheckListReports,
        TextId: 'checklist_reports.module_name',
        BaseState: FiStateNames.Checklist.Report._name,
    },
    {
        Id: ModuleType.ForumPost,
        TextId: 'forum.module_name',
        BaseState: FiStateNames.Forum._name,
    },
    {
        Id: ModuleType.CustomerBilling,
        TextId: 'billing.customer_billing',
    },
];

export const ModuleTypesMap = createMap(ModuleTypes, 'Id');

export const BillingModuleTypes = [
    {
        Id: BillingModuleType.CoreUsersCharge,
        TextId: 'billing.moduleType.CoreUsers',
    },
    {
        Id: BillingModuleType.CoreUnitsCharge,
        TextId: 'billing.moduleType.CoreUnits',
    },
    {
        Id: BillingModuleType.Checklists,
        TextId: 'billing.moduleType.Checklists',
    },
    {
        Id: BillingModuleType.SslCerts,
        TextId: 'billing.moduleType.SslCerts',
    },
    {
        Id: BillingModuleType.SslCertsUnitCharge,
        TextId: 'billing.moduleType.SslCertsUnitCharge',
    },
    {
        Id: BillingModuleType.sslCertsUserCharge,
        TextId: 'billing.moduleType.SslCertsUserCharge',
    },
];
